export interface TodayAppointment {
  id: number;
  customer: string;
  service: string;
  staff: string;
  time: string;
  status: 'completed' | 'in_progress' | 'upcoming' | 'cancelled' | 'no_show';
  duration: string;
  amount: string;
  paymentStatus: 'paid' | 'unpaid' | 'partial';
}

export const todayAppointments: TodayAppointment[] = [
  {
    id: 1,
    customer: 'Ahmet Yılmaz',
    service: 'Masaj Seansı',
    staff: 'Ayşe K.',
    time: '09:00',
    status: 'completed',
    duration: '60 dk',
    amount: '₺450',
    paymentStatus: 'paid',
  },
  {
    id: 2,
    customer: 'Fatma Kaya',
    service: 'Cilt Bakımı',
    staff: 'Zeynep D.',
    time: '10:00',
    status: 'completed',
    duration: '45 dk',
    amount: '₺380',
    paymentStatus: 'paid',
  },
  {
    id: 3,
    customer: 'Mehmet Öz',
    service: 'SPA Paket',
    staff: 'Burak T.',
    time: '11:00',
    status: 'in_progress',
    duration: '120 dk',
    amount: '₺950',
    paymentStatus: 'unpaid',
  },
  {
    id: 4,
    customer: 'Zeynep Şahin',
    service: 'Manikür',
    staff: 'Elif Y.',
    time: '12:00',
    status: 'upcoming',
    duration: '30 dk',
    amount: '₺220',
    paymentStatus: 'unpaid',
  },
  {
    id: 5,
    customer: 'Hakan Mert',
    service: 'Masaj Seansı',
    staff: 'Ayşe K.',
    time: '13:00',
    status: 'upcoming',
    duration: '60 dk',
    amount: '₺450',
    paymentStatus: 'unpaid',
  },
  {
    id: 6,
    customer: 'Ayşe Demir',
    service: 'Cilt Bakımı',
    staff: 'Zeynep D.',
    time: '14:30',
    status: 'upcoming',
    duration: '45 dk',
    amount: '₺380',
    paymentStatus: 'unpaid',
  },
  {
    id: 7,
    customer: 'Seda Arslan',
    service: 'Pedikür',
    staff: 'Elif Y.',
    time: '15:30',
    status: 'upcoming',
    duration: '40 dk',
    amount: '₺250',
    paymentStatus: 'unpaid',
  },
  {
    id: 8,
    customer: 'Burak Tekin',
    service: 'SPA Paket',
    staff: 'Mehmet S.',
    time: '16:30',
    status: 'upcoming',
    duration: '120 dk',
    amount: '₺950',
    paymentStatus: 'partial',
  },
  {
    id: 9,
    customer: 'Elif Yıldız',
    service: 'Manikür + Pedikür',
    staff: 'Elif Y.',
    time: '17:30',
    status: 'upcoming',
    duration: '60 dk',
    amount: '₺420',
    paymentStatus: 'unpaid',
  },
  {
    id: 10,
    customer: 'Canan Özdemir',
    service: 'Masaj Seansı',
    staff: 'Ayşe K.',
    time: '18:30',
    status: 'upcoming',
    duration: '60 dk',
    amount: '₺450',
    paymentStatus: 'unpaid',
  },
];